export default {
  'app.settings.menuMap.basic': '基本設定',
  'app.settings.menuMap.security': 'セキュリティ設定',
  'app.settings.menuMap.binding': 'アカウント連携',
  'app.settings.menuMap.notification': '新着メッセージ通知',
  'app.settings.basic.avatar': 'アバター',
  'app.settings.basic.change-avatar': 'アバターを変更',
  'app.settings.basic.email': 'メール',
  'app.settings.basic.email-message': 'メールアドレスを入力してください！',
  'app.settings.basic.nickname': 'ニックネーム',
  'app.settings.basic.nickname-message': 'ニックネームを入力してください！',
  'app.settings.basic.profile': '個人プロフィール',
  'app.settings.basic.profile-message': '個人プロフィールを入力してください！',
  'app.settings.basic.profile-placeholder': '自己紹介',
  'app.settings.basic.country': '国/地域',
  'app.settings.basic.country-message': '国を入力してください！',
  'app.settings.basic.geographic': '都道府県または市',
  'app.settings.basic.geographic-message': '地理情報を入力してください！',
  'app.settings.basic.address': '住所',
  'app.settings.basic.address-message': '住所を入力してください！',
  'app.settings.basic.phone': '電話番号',
  'app.settings.basic.phone-message': '電話番号を入力してください！',
  'app.settings.basic.update': '情報更新',
  'app.settings.security.strong': '強',
  'app.settings.security.medium': '中',
  'app.settings.security.weak': '弱',
  'app.settings.security.password': 'アカウントパスワード',
  'app.settings.security.password-description': '現在のパスワード強度',
  'app.settings.security.phone': 'セキュリティ電話',
  'app.settings.security.phone-description': '連携済み電話番号',
  'app.settings.security.question': 'セキュリティ質問',
  'app.settings.security.question-description':
    'セキュリティ質問が設定されておらず、セキュリティポリシーでアカウントセキュリティを効果的に保護できます',
  'app.settings.security.email': 'バックアップメール',
  'app.settings.security.email-description': '連携済みメール',
  'app.settings.security.mfa': 'MFAデバイス',
  'app.settings.security.mfa-description':
    '未連携MFAデバイス、連携後に二重確認が可能',
  'app.settings.security.modify': '変更',
  'app.settings.security.set': '設定',
  'app.settings.security.bind': '連携',
  'app.settings.binding.taobao': 'Taobao連携',
  'app.settings.binding.taobao-description': '現在未連携のTaobaoアカウント',
  'app.settings.binding.alipay': 'Alipay連携',
  'app.settings.binding.alipay-description': '現在未連携のAlipayアカウント',
  'app.settings.binding.dingding': 'DingTalk連携',
  'app.settings.binding.dingding-description':
    '現在未連携のDingTalkアカウント',
  'app.settings.binding.bind': '連携',
  'app.settings.notification.password': 'アカウントパスワード',
  'app.settings.notification.password-description':
    '他のユーザーからのメッセージはステーションレターの形で通知されます',
  'app.settings.notification.messages': 'システムメッセージ',
  'app.settings.notification.messages-description':
    'システムメッセージはステーションレターの形で通知されます',
  'app.settings.notification.todo': 'To-do通知',
  'app.settings.notification.todo-description':
    'To-doリストはステーションからのレターの形で通知されます',
  'app.settings.open': '開く',
  'app.settings.close': '閉じる',
};